<template>
    <div
        class="modal fade text-left"
        :id="id"
    >
        <div class="modal-dialog modal-dialog-centered modal-md" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="bureau-address-title">
                        {{ localizationStore.translate('select.bureau.address.title') }}
                    </h4>
                    <button @click="closeModal(`#${id}`)" type="button" class="close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group">
                        <label for="transunion-address">TransUnion Address</label>
                        <select
                            v-if="reportStore.creditbureaus['TransUnion']?.selected_address"
                            v-model="reportStore.creditbureaus['TransUnion'].selected_address"
                            class="form-control"
                            id="transunion-address"
                            required
                        >
                            <option v-for="(address, value) in reportStore.creditbureaus['TransUnion']?.addresses" :value="address.id">
                                {{ address.street }}, {{ address.city }}, {{ address.state_abbreviation }} {{ address.zipcode }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label for="experian-address">Experian Address</label>
                        <select
                            v-if="reportStore.creditbureaus['Experian']?.selected_address"
                            v-model="reportStore.creditbureaus['Experian'].selected_address"
                            class="form-control"
                            id="experian-address"
                            required
                        >
                            <option v-for="(address, value) in reportStore.creditbureaus['Experian']?.addresses" :value="address.id">
                                {{ address.street }}, {{ address.city }}, {{ address.state_abbreviation }} {{ address.zipcode }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label for="equifax-address">
                            Equifax Address
                        </label>
                        <select
                            v-if="reportStore.creditbureaus['Equifax']?.selected_address"
                            v-model="reportStore.creditbureaus['Equifax'].selected_address"
                            class="form-control"
                            id="equifax-address"
                            required
                        >
                        <option v-for="(address, value) in reportStore.creditbureaus['Equifax']?.addresses" :value="address.id">
                            {{ address.street }}, {{ address.city }}, {{ address.state_abbreviation }} {{ address.zipcode }}
                        </option>
                        </select>
                    </div>
                </div>
                <div class="modal-footer">
                    <button @click="reportStore.createAttack(reportStore.letterSlug, $event)" type="button" class="btn btn-primary">
                        {{ localizationStore.translate('create.attack') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { useLocalizationStore } from '../../stores/LocalizationStore.js'
    import { closeModal } from '../../utilities/_helpers'
    import { useReportStore } from '../../stores/ReportStore.js'
    export default {
        props: {
            id: String,
            slug: String
        },
        mounted() {
        },
        setup(props) {
            return {
                closeModal: closeModal,
                localizationStore: useLocalizationStore(),
                reportStore: useReportStore(),
            }
        },
    }
</script>